import React from 'react';
import { Button } from 'reactstrap'
import JSZip from 'jszip';
import Lang from 'Lang/General'
import { saveAs } from 'file-saver';

const getFileExtension = (url) => {
  return url.split('.').pop(); // Extracts the extension like 'jpeg', 'png', etc.
};
const ImageDownloader = ({ allImageUrls, imageUrls, lang, style, onHandleLoading }) => {
  const downloadImages = async (context) => {
    onHandleLoading(true)
    const zip = new JSZip();

    let temp = context === 'all' ? [...allImageUrls] : [...imageUrls]

    // Loop through all URLs and group them into different folders
    for (let i = 0; i < temp.length; i++) {
      const imageUrl = temp[i].url;
      try {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const extension = getFileExtension(imageUrl);

        // Extract the folder name from the URL (based on prefix)
        const folderName = `${temp[i].short_company_name.replaceAll(' ', '_').toLowerCase()}_media`
        const folder = zip.folder(folderName); // Create folder based on the URL prefix
        const newFileName = `${temp[i].company.replaceAll(' ', '_').toLowerCase()}_${temp[i].media_type.replaceAll(' ', '_').toLowerCase()}.${extension}`;
        // const fileName = imageUrl.split('/').pop(); // Get file name from the URL
        folder.file(newFileName, blob); // Add the file to the appropriate folder
      } catch (error) {
        console.error(`Error downloading ${imageUrl}: `, error);
      }
    }

    // Generate the zip file and trigger download
    zip.generateAsync({ type: 'blob' }).then((content) => {
      onHandleLoading(false)
      saveAs(content, `${temp?.[0]?.fair_short_title.replaceAll(' ', '_').toLowerCase()}_media.zip`); // Download the zip file
    });
  };

  return (
    <div className='d-flex mb-3'>
      <Button
        className={'mr-2'}
        color={'primary'} disabled={allImageUrls.length < 1} onClick={() => downloadImages('all')}
        style={{ marginLeft: 'auto' }}
      >
        {Lang['DOWNLOAD_ALL'][lang]}
      </Button>
      {
        imageUrls?.[0] && (
          <Button
            color={'primary'} disabled={imageUrls.length < 1} onClick={() => downloadImages('selected')}
          >
            {Lang['DOWNLOAD_SELECTED'][lang]}
          </Button>
        )
      }
    </div>
  );
};

export default ImageDownloader;
